module.exports = __webpack_public_path__ + "static/img/peizi_logo.9b82587.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/peizi_logo.gif
// module id = RmGR
// module chunks = 1